/* eslint-disable jsx-a11y/no-static-element-interactions */
import { Container } from './index.styles';
import { generateId } from '../../utils/helpers';

interface Options {
  count?: number | string;
  featureRestriction?: string;
  groupCount?: number | string;
  label: string;
  route: string;
  isBeta?: boolean;
}

export interface SidebarProps {
  /**
   * Will feature option[activeIndex] as active. Required.
   */
  activeIndex: number;
  /**
   * Header name. Required.
   */
  header: string;
  /**
   * Navigation event emmiter. It emmit the event to the parent with the clicked option label. Required.
   */
  onNavClick: (route: string) => void;
  /**
   * Navigation options. E.g.: [{ label: 'calendar', url: '#calendar', count: 0, groupCount: 0 }]. Required.
   */
  options: Options[];
  /**
   * Add 'open' class when in small viewport if sidebar is open. Optional.
   */
  responsiveIsOpen?: boolean;
}

type FeatureManagerWindow = Window & {
  js_featurMngr?: {
    getFeatureStatus?: (featureCode: string) => string;
    openFeatureGatingPopup?: (featureCode: string) => void;
  };
};

/**
 * Sidebar
 */
export const Sidebar = (props: SidebarProps) => {
  const { activeIndex, header, onNavClick, options, responsiveIsOpen = false } = props;
  const featureManager = (window as FeatureManagerWindow).js_featurMngr;

  const handleOptionClick = (route: string, featureRestriction?: string) => {
    if (typeof featureRestriction === 'string' && featureManager?.getFeatureStatus) {
      const featureStatus = featureManager.getFeatureStatus(featureRestriction);

      if ((featureStatus === 'restricted' || featureStatus === 'limited') && featureManager?.openFeatureGatingPopup) {
        featureManager.openFeatureGatingPopup(featureRestriction);

        return;
      }
    }

    onNavClick(route);
  };

  const optionList = options.map((option, index) => {
    const { count, featureRestriction, groupCount, isBeta, label, route } = option;

    return (
      <li
        key={generateId()}
        data-testid={`legacy-sidebar-li-${index}`}
        className={`${index === activeIndex ? 'activeItem' : ''} ${index === options.length - 1 ? 'last' : ''}`}
        title=""
      >
        <a
          className="feature-check"
          onClick={(e) => {
            e.preventDefault();
            handleOptionClick(route, featureRestriction);
          }}
          style={{ cursor: 'default' }}
        >
          {label}
          {isBeta && <span className="badge badge-warning text-uppercase">Beta</span>}
          {count !== undefined && (
            <span
              className="badge badge-info scheduled-info"
              data-original-title
            >
              <span className="schedule-count">{count}</span>
              {groupCount !== undefined && <span className="schedule-team-count">{` (${groupCount})`}</span>}
            </span>
          )}
        </a>
      </li>
    );
  });

  return (
    <Container
      id="left-sidebar"
      className={`well sidebar-nav equal-height ${responsiveIsOpen ? 'open' : ''}`}
    >
      <ul
        id="engage-sidebar"
        className="nav nav-list"
      >
        <li className="nav-header outbox-header">{header}</li>
        {optionList}
      </ul>
    </Container>
  );
};
